import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { prop } from '../../../../../../common/utils/immutableHelper';

import { autoUpdateInstallUpdate, autoUpdateForcePoll } from '../../../../../../common/electron/electronActions';

import Spinner from '../../../../../components/loaders/Spinner';
import LinkButton from '../../../../../components/buttons/LinkButton';
import ProgressBar from '../../../../../element/file/uploader/ProgressBar';

import electronUpdateSelector from './electronUpdateSelector';

import { AUTOUPDATE_STATE } from '../../../../../../common/electron/electronConstants';

import './ElectronUpdateStatus.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchInstallUpdate: () => dispatch(autoUpdateInstallUpdate()),
    dispatchForcePoll: () => dispatch(autoUpdateForcePoll()),
});

const getPercent = prop('percent');

const UpdateProgressDisplay = ({ updateProgress }) => {
    const percent = Math.round(getPercent(updateProgress) || 0);

    return (
        <div className="UpdateProgressDisplay">
            <ProgressBar barbershop animate percentageComplete={percent} />
            {percent}%
        </div>
    );
};

UpdateProgressDisplay.propTypes = {
    updateProgress: PropTypes.object,
};

const UpdateStatus = ({ autoUpdate, dispatchInstallUpdate, dispatchForcePoll, updateProgress }) => {
    switch (autoUpdate) {
        case AUTOUPDATE_STATE.DOWNLOADING:
            return (
                <div className="UpdateStatus downloading">
                    <UpdateProgressDisplay updateProgress={updateProgress} />
                </div>
            );
        case AUTOUPDATE_STATE.CHECKING:
            return (
                <div className="UpdateStatus downloading">
                    <Spinner show />
                </div>
            );
        case AUTOUPDATE_STATE.READY:
            return (
                <div className="UpdateStatus ready">
                    <span className="bullet">●</span>{' '}
                    <LinkButton onClickFn={dispatchInstallUpdate}>Install update</LinkButton>{' '}
                </div>
            );
        case AUTOUPDATE_STATE.ERROR:
            return (
                <div className="UpdateStatus error">
                    <span className="bullet">▲</span> Update failed
                    <LinkButton onClickFn={dispatchForcePoll}>Retry</LinkButton>
                </div>
            );
        default:
            return (
                <div className="UpdateStatus up-to-date">
                    <span className="bullet">●</span> Up to date
                </div>
            );
    }
};

const ElectronAppStatus = (props) => <UpdateStatus {...props} />;

ElectronAppStatus.propTypes = UpdateStatus.propTypes = {
    autoUpdate: PropTypes.string,
    version: PropTypes.string,
    updateProgress: PropTypes.object,
    dispatchInstallUpdate: PropTypes.func,
    dispatchForcePoll: PropTypes.func,
};

export const ElectronUpdateStatus = connect(electronUpdateSelector, mapDispatchToProps)(UpdateStatus);

export default connect(electronUpdateSelector, mapDispatchToProps)(ElectronAppStatus);
